import React from "react";
import AppRouter from "./Router";
// import Navbar from "../components/sections/Navbar";
// import Footer from "../components/sections/Footer";

function App() {
  return <AppRouter />;
}

export default App;
